//====== SPACING VARIABLES ======//
export const extra_small_space = "8px";
export const small_space = "16px";
export const medium_space_1 = "24px";
export const medium_space_2 = "32px";
export const medium_space_3 = "40px";
export const large_space = "56px";
export const extra_large_space = "80px";
